import { UseFormReturn, useController } from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import { FormControlLabel, Switch } from "@fxc/ui-kit";
import {
  getTextWidth,
  getCanvasFont,
} from "@/entities/client/lib/getTextWidth";
import { IClientEditableProps } from "@/pages/clients/client/ClientEditableFields";
import TextFieldElement from "@/components/TextFieldElement";

export function InputBaseURL({
  form: { control },
  baseUrl: { startAdornment, endAdornment },
  default_app_url,
}: {
  form: UseFormReturn<IClientEditableProps, any>;
  baseUrl: {
    startAdornment: string;
    endAdornment: string;
  };
  default_app_url: string;
}) {
  const prevCustomUrl = useRef("");
  const { field: baseUrlField } = useController({
    control,
    name: "applicationBaseUrl",
  });
  const { value: baseUrlValue } = baseUrlField;

  const [useCustomBaseUrl, setUseCustomBaseUrl] = useState<true | undefined>(
    baseUrlValue !== default_app_url || undefined,
  );
  useEffect(() => {
    setUseCustomBaseUrl(baseUrlValue !== default_app_url ? true : undefined);
  }, [baseUrlValue, default_app_url]);

  const placeholder = "custom sub domain";
  return (
    <>
      <FormControlLabel
        disabled={!default_app_url}
        style={{ pointerEvents: "none" }}
        sx={{ mb: -2 }}
        control={
          <Switch
            data-qa="custom-url-switch"
            checked={!!useCustomBaseUrl}
            style={{ pointerEvents: "all" }}
            onChange={(_, checked) => {
              if (!default_app_url) {
                return;
              }
              setUseCustomBaseUrl(checked || undefined);
              if (prevCustomUrl.current === default_app_url && checked) {
                prevCustomUrl.current = "";
              }
              baseUrlField.onChange(
                checked ? prevCustomUrl.current : default_app_url,
              );
              prevCustomUrl.current = baseUrlValue ?? "";
            }}
          />
        }
        label="Custom URL"
      />
      <TextFieldElement
        data-qa="application-base-url"
        label={"Base URL"}
        disabled={!useCustomBaseUrl}
        slotProps={{
          input: useCustomBaseUrl
            ? { startAdornment, endAdornment }
            : undefined,
          htmlInput: {
            "aria-autocomplete": "none",
            style: {
              width: `${
                getTextWidth(baseUrlValue || placeholder, getCanvasFont()) *
                  1.02 +
                1
              }px`,
            },
          },
        }}
        placeholder={placeholder}
        fullWidth
        sx={{
          ...(useCustomBaseUrl && {
            "& input": {
              textAlign: baseUrlValue ? "center" : undefined,
              backgroundColor: "rgb(0, 0, 0, 0.15)",
              borderRadius: 1,
              px: 0.25,
              mx: 0.125,
            },
          }),
          "input::placeholder": {
            textAlign: "center",
          },
        }}
        required
        name={"applicationBaseUrl"}
        control={control}
        type="url"
      />
    </>
  );
}
